/* eslint-disable */
import * as Types from '../../../types';

import gql from 'graphql-tag';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/react-hooks';

const defaultOptions = {} as const;
export type UserContextQueryQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type UserContextQueryQuery = {
  __typename?: 'Query';
  user?: {
    __typename?: 'User';
    id: string;
    features: { loggedInHomePage: boolean };
    package: { __typename?: 'UserPackage'; id: string; canonicalName: string };
    preferences: {
      hasSeenLIHPWelcomeModal: boolean;
      newHomePageEnabled: boolean;
    };
  } | null;
};

export const UserContextQueryDocument = gql`
  query userContextQuery {
    user {
      id
      features {
        loggedInHomePage
      }
      preferences {
        hasSeenLIHPWelcomeModal
        newHomePageEnabled
      }
      package {
        id
        canonicalName
      }
    }
  }
`;

/**
 * __useUserContextQueryQuery__
 *
 * To run a query within a React component, call `useUserContextQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserContextQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserContextQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserContextQueryQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    UserContextQueryQuery,
    UserContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    UserContextQueryQuery,
    UserContextQueryQueryVariables
  >(UserContextQueryDocument, options);
}

export function useUserContextQueryLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    UserContextQueryQuery,
    UserContextQueryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    UserContextQueryQuery,
    UserContextQueryQueryVariables
  >(UserContextQueryDocument, options);
}

export type UserContextQueryQueryHookResult = ReturnType<
  typeof useUserContextQueryQuery
>;
export type UserContextQueryLazyQueryHookResult = ReturnType<
  typeof useUserContextQueryLazyQuery
>;
export type UserContextQueryQueryResult = ApolloReactCommon.QueryResult<
  UserContextQueryQuery,
  UserContextQueryQueryVariables
>;
